import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CityService } from '@city/feature';
import { GeoPoint } from '@core/const';
import { OccEndpointsService, Suggestion } from '@spartacus/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, finalize, map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class AddressSuggestionsService {
  loading$: Observable<boolean>;
  suggestions$: Observable<Suggestion[]>;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private suggestionsSubject = new BehaviorSubject<Suggestion[]>([]);
  private cityService = inject(CityService);
  private currentPosition$: Observable<GeoPoint | undefined>;
  private occEndpointsService = inject(OccEndpointsService);

  constructor(private http: HttpClient) {
    this.loading$ = this.loadingSubject.asObservable();
    this.suggestions$ = this.suggestionsSubject.asObservable();

    this.currentPosition$ = this.cityService.activeBaseStore$.pipe(map((res) => res?.cityGeoPoint));
  }

  loadSuggestions = (query: string): void => {
    if (!query) return;

    this.loadingSubject.next(true);

    this.currentPosition$
      .pipe(
        filter(Boolean),
        take(1),
        switchMap((position: GeoPoint) => {
          const url = this.occEndpointsService.getBaseUrl({ prefix: false, baseSite: false });

          return this.http
            .get(`${url}/utils/suggest-maps`, {
              params: {
                text: query,
                results: 5,
                types: 'geo,street,district,locality,area,province,house',
                print_address: 1,
                spn: '0.5,0.5',
                ll: `${position.longitude},${position.latitude}`,
                countries: 'ru',
              },
            })
            .pipe(
              map((res: any) => res.results.map((item: any) => item.address.formatted_address)),
              catchError((error) => {
                this.suggestionsSubject.next([]);

                return throwError(() => error);
              }),
              finalize(() => {
                this.loadingSubject.next(false);
              }),
            );
        }),
      )
      .subscribe((res: any) => {
        this.suggestionsSubject.next(res);
      });
  };
}
